export default "__VITE_ASSET__nXWrwh8f__"